<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <h6>工厂及产品文件</h6>
        </div>
        <div>
          <a v-b-toggle.collapse-file role="button" style="color: #606266">
            <i v-if="isShowPanel" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </div>
      </div>
      <b-collapse v-model="isShowPanel" id="collapse-file">
        <vxe-grid
          class="mt-3"
          ref="table"
          border="inner"
          auto-resize
          round
          highlight-hover-row
          :data="tableData"
          :columns="tableColumn"
          :loading="loading"
          :seq-config="{}"
        >
          <template v-slot:displayFileDesc="{ row }">
            <el-link
              type="primary"
              style="text-decoration: underline"
              @click.stop="viewFile(row)"
              >{{ row.scmImageDesc }}</el-link
            >
          </template>
          <template v-slot:displayUpload="{ row }">
            <span>{{ row.userNameEn }}</span>
            <br />
            <span>{{ row.createTime }}</span>
          </template>
          <template v-slot:opt="{ row }">
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                :content="'查看'"
                placement="top"
              >
                <i class="el-icon-view tool-btn" @click="viewFile(row)"></i>
              </el-tooltip>
            </div>
          </template>
        </vxe-grid>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.params.scmCode) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isBusy: false,
      isShowPanel: true,
      loading: false,
      tableData: [],
      tableColumn: [
        {
          field: 'col-opt',
          title: '',
          align: 'center',
          width: 50,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'scmImageDesc',
          minWidth: 150,
          title: '文件名称',
          slots: {
            default: 'displayFileDesc',
          },
        },
        {
          field: 'userNameEn',
          width: 170,
          title: '上传人',
          slots: {
            default: 'displayUpload',
          },
        },
      ],
    }
  },
  mounted() {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .opaScmImageListApi(params)
        .then((res) => {
          this.isBusy = false
          let data = this.filterImage(res.body.data)
          this.tableData = data
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    //过滤图片数据
    filterImage(data) {
      const filter = ['jpeg', 'png', 'jpg', 'gif']
      return data.filter((item) => {
        return !filter.includes(
          item.scmImageCode.substring(item.scmImageCode.indexOf('.') + 1)
        )
      })
    },
    // 查看文件
    viewFile({ previewUrl }) {
      window.open(previewUrl, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  margin: 20px 10px;
}
</style>
